var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1028 17.9789C14.0181 22.0636 7.37802 22.0636 3.29338 17.9789C-0.791265 13.8943 -0.791265 7.25415 3.29338 3.16951C7.37802 -0.915133 14.0181 -0.915133 18.1028 3.16951C22.1874 7.25415 22.1874 13.8943 18.1028 17.9789ZM4.32659 4.20273C0.813662 7.71566 0.813662 13.4328 4.32659 16.9457C7.83952 20.4586 13.5566 20.4586 17.0696 16.9457C20.5825 13.4328 20.5825 7.71566 17.0696 4.20273C13.5566 0.689795 7.83952 0.689795 4.32659 4.20273Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.528 9.95459L11.1497 12.3329C10.8688 12.6138 10.4092 12.6138 10.1283 12.3329L7.75 9.95459",
    stroke: "white",
    strokeWidth: 1.7509,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowCircle);
export default __webpack_public_path__ + "static/media/down_arrow_circle.e803930e52592974eebd1fee82e10d92.svg";
export { ForwardRef as ReactComponent };